<template>
  <div id="StdAttribute" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row :gutter="10" type="flex" justify="space-between" class="h-36px">
        <el-col :span="24" class="h-full flex">
          <selectStandardId @updateStandardId="updateStandardId" />
          <el-input
            class="w-200px ml-10px"
            size="small"
            :placeholder="`${$t('pleaseEnterCodeOrName')}`"
            v-model.trim="keyword"
            clearable
          />
          <el-button class="ml-10px" type="primary" size="small" @click="searchTableData()">{{
            $t('search')
          }}</el-button>
          <el-button
            type="primary"
            size="small"
            :disabled="!$hasAccess('create')"
            @click="addAttribute"
            >{{ $t('create') }}</el-button
          >
          <el-button
            type="danger"
            size="small"
            :disabled="!$hasAccess('delete')"
            @click="delAttr(selectList)"
            >{{ $t('delete') }}</el-button
          >
          <el-button
            type="primary"
            :loading="effectLoading"
            @click="openEffectAnalysis('effect', idList)"
            >影响分析</el-button
          >
          <el-button size="small" @click="exportFile" :disabled="!$hasAccess('export')">{{
            $t('export')
          }}</el-button>
          <el-button size="small" @click="importFile" :disabled="!$hasAccess('import')">{{
            $t('import')
          }}</el-button>
        </el-col>
      </el-row>
      <el-table
        border
        :data="tableData"
        v-loading="tableLoading"
        :highlight-current-row="true"
        @selection-change="handleSelectionChange"
        height="calc(100% - 104px)"
        ref="multipleTable"
        class="mt-20px"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column :label="`${$t('seqNo')}`" prop="seqNo" width="55"></el-table-column>
        <el-table-column
          :label="`${$t('code')}`"
          prop="code"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="`${$t('name')}`"
          prop="name"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column :label="`${$t('valueType')}`" prop="valueTypeName"> </el-table-column>
        <el-table-column :label="$t('参考数据')" prop="referenceDataClassName"> </el-table-column>
        <!-- <el-table-column
          show-overflow-tooltip
          :label="$t('metaDataName')"
          prop="metaDataName"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          :label="$t('metaDataCode')"
          prop="metaDataCode"
        ></el-table-column> -->
        <el-table-column :label="`${$t('length')}`" prop="length"></el-table-column>
        <el-table-column :label="`${$t('decimalPoint')}`" prop="decimalPoint"></el-table-column>
        <!-- <el-table-column label="单位"
        prop="unitId"> </el-table-column>-->
        <el-table-column
          :label="`${$t('remarks')}`"
          prop="remark"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column :label="`${$t('operate')}`" width="200">
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('read')"
              size="mini"
              @click="viewAttr(scope.row.id)"
              >{{ $t('view') }}</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('update') || scope.row.disabled"
              @click="editAttr(scope.row.id)"
              >{{ $t('edit') }}</el-button
            >
            <el-button
              size="mini"
              :disabled="!$hasAccess('delete') || scope.row.disabled"
              @click="delAttr([scope.row])"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="recordCount"
      ></el-pagination>
      <!-- 新增标准属性弹框 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="attrDialog"
        :close-on-click-modal="false"
        v-dialogDrag
        width="940px"
      >
        <el-form
          label-width="100px"
          ref="queryForm"
          :rules="currentLang === 'zh' ? queryFormRules : queryFormEnRules"
          :model="queryForm"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="`${$t('seqNo')}`" prop="seqNo" class="w-full">
                <el-input-number
                  v-model="queryForm.seqNo"
                  :controls="false"
                  :disabled="dialogTitle === $t('standardAttributeDetail')"
                  size="small"
                  class="w-full"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="`${$t('code')}`" prop="code" class="w-full">
                <el-input
                  size="small"
                  clearable
                  v-model.trim="queryForm.code"
                  :disabled="dialogTitle === $t('standardAttributeDetail')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="`${$t('name')}`" prop="name" class="w-full">
                <el-input
                  size="small"
                  clearable
                  v-model.trim="queryForm.name"
                  :disabled="dialogTitle === $t('standardAttributeDetail')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 关联标识 -->
            <!-- <el-col :span="12">
              <el-form-item :label="`${$t('relationIdentify')}`" prop="identifierIds">
                <el-select
                  size="small"
                  :disabled="dialogTitle === $t('standardAttributeDetail')"
                  clearable
                  filterable
                  v-model="queryForm.identifierIds"
                  :placeholder="`${$t('pleaseSelect')}`"
                  class="w-full"
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="item in relationLabelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                    <span class="l m-r-10">{{ item.groupCodeIdentifierCode }}</span>
                    <span class="text-color-grey-ccc fz-14 r">{{ item.code }}-{{ item.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item :label="`${$t('valueType')}`" prop="valueType">
                <el-select
                  v-model="queryForm.valueType"
                  filterable
                  clearable
                  :placeholder="`${$t('pleaseSelect')}`"
                  class="w-full"
                  :disabled="dialogTitle === $t('standardAttributeDetail')"
                  size="small"
                >
                  <el-option
                    v-for="item in valueTypeList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 数据类型为【布尔，日期时间，日期，时间】时，长度禁止编辑且固定长度 -->
              <el-form-item :label="`${$t('length')}`" prop="length">
                <el-input-number
                  v-model="queryForm.length"
                  :controls="false"
                  size="small"
                  :disabled="
                    dialogTitle === $t('standardAttributeDetail') ||
                      _.includes([4, 6, 8, 9], queryForm.valueType)
                  "
                  class="w-full"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('decimalPoint')" prop="decimalPoint">
                <el-input-number
                  v-model="queryForm.decimalPoint"
                  :disabled="
                    queryForm.valueType !== 3 || dialogTitle === $t('standardAttributeDetail')
                  "
                  :controls="false"
                  @keyup.native="proving($event)"
                  size="small"
                  class="w-full"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('参考数据')">
                <el-select
                  class="w-full"
                  size="small"
                  v-model="queryForm.referenceDataClassId"
                  :placeholder="`${$t('pleaseSelect')}`"
                  :disabled="
                    dialogTitle === $t('standardAttributeDetail') ||
                      ![5, 7].includes(queryForm.valueType)
                  "
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in referenceDataList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 数据类型为布尔时，单位禁止编辑 -->
              <el-form-item :label="`${$t('unit')}`" prop="unitId">
                <el-select
                  v-model="queryForm.unitId"
                  clearable
                  filterable
                  :placeholder="`${$t('pleaseSelect')}`"
                  class="w-full"
                  size="small"
                  :disabled="
                    dialogTitle === $t('standardAttributeDetail') || queryForm.valueType === 4
                  "
                >
                  <el-option
                    v-for="item in unitList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                    <span style="float: left">{{ item.unitTypeName }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">
                      {{ item.name }}
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item :label="$t('metaDataCode')" prop="metaDataId">
                <el-select
                  v-model="queryForm.metaDataId"
                  filterable
                  clearable
                  :placeholder="`${$t('pleaseSelect')}`"
                  class="w-full"
                  @change="metaDatachange"
                  :disabled="dialogTitle === $t('standardAttributeDetail')"
                  size="small"
                >
                  <el-option
                    v-for="item in metaDataList"
                    :key="item.id"
                    :label="`${item.metaDataCode}--------${item.tableName}`"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="12">
              <el-form-item :label="$t('metaDataName')">
                <el-input
                  size="small"
                  clearable
                  v-model.trim="queryForm.metaDataName"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item :label="`${$t('remarks')}`" prop="remark" class="w-full">
                <el-input
                  size="small"
                  v-model.trim="queryForm.remark"
                  type="textarea"
                  :disabled="dialogTitle === $t('standardAttributeDetail')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 个性元数据 -->
            <el-col :span="12" v-for="(item, index) in personalityMetaData" :key="index">
              <!-- 字符串，整数，小数 -->
              <el-form-item
                v-if="['1', '2', '3'].includes(item.dataType)"
                :label="item.name"
                class="w-full"
              >
                <el-input
                  type="text"
                  size="small"
                  v-model.trim="item.dataValue"
                  :max-length="item.dataType === '1' ? item.length : ''"
                  :disabled="dialogTitle === $t('standardAttributeDetail')"
                  @input="metaDataInputChange($event, item.dataType, item)"
                  clearable
                ></el-input>
              </el-form-item>
              <!-- 布尔 -->
              <el-form-item v-if="item.dataType === '4'" :label="item.name" class="w-full">
                <el-radio-group
                  v-model="item.dataValue"
                  :disabled="dialogTitle === $t('standardAttributeDetail')"
                >
                  <el-radio label="true">{{ $t('yes') }}</el-radio>
                  <el-radio label="false">{{ $t('no') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 日期时间 -->
              <el-form-item v-if="item.dataType === '5'" :label="item.name" class="w-full">
                <el-date-picker
                  v-model="item.dataValue"
                  type="datetime"
                  class="!w-full"
                  :disabled="dialogTitle === $t('standardAttributeDetail')"
                ></el-date-picker>
              </el-form-item>
              <!-- 枚举 -->
              <el-form-item v-if="item.dataType === '6'" :label="item.name" class="w-full">
                <el-select
                  size="small"
                  class="w-full"
                  v-model="item.dataValue"
                  :disabled="attributeTitle === $t('attributeDetail')"
                  :placeholder="$t('pleaseSelect')"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="val in item.referenceItemsList"
                    :key="val.id"
                    :label="val.name"
                    :value="val.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer tc"
          v-if="dialogTitle !== $t('standardAttributeDetail')"
        >
          <el-button type="primary" @click="queryFormSave('queryForm')" :loading="isLoading">{{
            $t('save')
          }}</el-button>
          <el-button @click="queryFormClose">
            {{ $t('cancel') }}
          </el-button>
        </div>
      </el-dialog>

      <wiz-upload-file
        v-dialogDrag
        @refreshList="searchTableData"
        :uploadFileProps="uploadFileProps"
        @exportTemplate="exportTemplate"
        @importTemplate="importTemplate"
      ></wiz-upload-file>
    </el-card>
    <!-- 影响分析弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="showEffectAnalysisDialog"
      :title="analysisTitle"
      width="940px"
      v-dialogDrag
    >
      <effectAnalysis
        v-if="showEffectAnalysisDialog"
        class="!h-640px"
        :analysisType="analysisType"
        :seriesData="effectAnalysisData"
      />
    </el-dialog>
  </div>
</template>
<script>
import CommonService from '@/services/Common'
import MetadataListService from '@/services/metadataListService'
import StdAttributeService from '@/services/StdAttributeService'
import StdClassAttributeService from '@/services/bsApi/StdClassAttributeService'
import StdIdentifierService from '@/services/StdIdentifierService'
import unitMeasureservice from '@/services/unitMeasureservice'
import ReferenceDataService from '@/services/ReferenceDataService'
import stdClassListService from '@/services/stdClassListService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'
import effectAnalysis from './components/effectAnalysis'

export default {
  name: 'StdAttribute',
  mixins: [fnMixin],
  components: {
    selectStandardId,
    effectAnalysis,
  },
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      totalSelection: [],
      dialogTitle: '',
      pageNo: 1,
      pageSize: 15,
      recordCount: 0,
      tableLoading: false,
      tableData: [],
      queryForm: {
        seqNo: 0,
        code: '',
        name: '',
        decimalPoint: '',
        remark: '',
        // identifierIds: [],
        standardId: this.standardId,
        valueType: '',
        length: '',
      },
      keyword: '',
      attrDialog: false,
      queryFormRules: {
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'change' },
          {
            required: true,
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: '请输入符合规则的代码',
            trigger: 'blur',
          },
        ],
        seqNo: [
          {
            required: false,
            pattern: /^\d*$/,
            message: this.$t('只能输入大于等于0整数'),
            trigger: 'change',
          },
        ],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        valueType: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      queryFormEnRules: {
        code: [
          { required: true, message: this.$t('pleaseEnterCode'), trigger: 'change' },
          {
            required: true,
            pattern: /^[\u0001-\u007F,\u0080-\uFFFF]+$/,
            message: this.$t('请输入符合规则的代码'),
            trigger: 'blur',
          },
        ],
        name: [{ required: true, message: this.$t('pleaseEnterTheName'), trigger: 'blur' }],
        valueType: [{ required: true, message: this.$t('pleaseSelect'), trigger: 'blur' }],
      },
      relationLabelList: [],
      unitList: [],
      valueTypeList: [],
      isLoading: false,
      idList: [],
      selectList: [],
      metaDataList: [],
      standardId: localStorage.getItem('standardId'),
      personalityMetaData: [],
      referenceDataList: [],
      analysisTitle: '',
      analysisType: '',
      showEffectAnalysisDialog: false,
      effectLoading: false,
      effectAnalysisData: [],
    }
  },
  computed: {
    currentLang() {
      return this.$store.getters['System/currentLang']
    },
  },
  watch: {
    async standardId(val) {
      if (val) {
        await this.searchTableData()
        await this.getUnitList()
      }
    },
    attrDialog(val) {
      if (!val) {
        this.queryForm = {
          code: '',
          name: '',
          decimalPoint: '',
          seqNo: '',
          remark: '',
          // identifierIds: [],
          standardId: this.standardId,
          valueType: '',
          length: '',
        }
        this.$refs.queryForm.clearValidate()
      }
    },
    'queryForm.valueType': {
      handler(val) {
        switch (val) {
          case 4:
            this.queryForm.length = 1
            break
          case 6:
            this.queryForm.length = 6
            break
          case 8:
            this.queryForm.length = 10
            break
          case 9:
            this.queryForm.length = 8
            break
          default:
            this.queryForm.length = 100
            break
        }
        if (val !== 3) {
          this.queryForm.decimalPoint = 0
        }
      },
    },
  },
  async created() {
    if (this.standardId) {
      this.searchTableData()
      this.getUnitList()
    }
    this.getRelationLabel()
    this.getValueTypeList()
    this.getMetaData()
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  methods: {
    // 获取参考数据下拉数据
    async getReferenceDataList() {
      const params = {
        SkipCount: 0,
        MaxResultCount: 999,
        standardId: this.standardId,
      }
      const res = await ReferenceDataService.getCategory(params)
      if (res && res.code === 0 && res.data) {
        this.referenceDataList = res.data
      }
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await CommonService.downloadTemplateCommon({
        reqUrl: 'std/StdAttribute/download_import_template?filter_attribute_group=1',
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '标准属性导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      const res = await CommonService.uploadFile({
        reqUrl: 'std/StdAttribute/import',
        reqData: formData,
      })
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: '标准属性导入明细.xlsx',
          data: res,
        })
        this.searchTableData()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 导出
    async exportFile() {
      const res = await StdAttributeService.exportFile({
        downloadFileName: '',
        urlParam: `?standard_id=${this.standardId}`,
        ids: _.map(this.totalSelection, (item) => {
          return item.id
        }),
        downloadType: 0,
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: '标准属性导出结果.xlsx',
          data: res,
        })
      }
    },
    updateStandardId(val) {
      this.standardId = val
    },
    // 获取元数据
    async getMetaData() {
      const payload = {
        pageno: 1,
        pageSize: 999,
      }
      const res = await MetadataListService.list(payload)
      if (res && res.data && res.code === 0) {
        this.metaDataList = res.data
      }
    },
    // 元数据值切换
    metaDatachange(val) {
      if (val) {
        this.queryForm.metaDataName = _.find(this.metaDataList, { id: val }).metaDataName
      } else {
        this.queryForm.metaDataName = ''
      }
    },
    handleSelectionChange(val) {
      _.forEach(this.totalSelection, (item) => {
        if (_.find(this.tableData, ['id', item.id])) {
          this.totalSelection = _.difference(this.totalSelection, [item])
        }
      })
      this.totalSelection = [...this.totalSelection, ...val]
      this.idList = _.map(val, (item) => {
        return item.id
      })
      this.selectList = val
    },
    proving(e) {
      const keyNum = window.event ? e.keyCode : e.which
      if (keyNum === 190 || keyNum === 110) {
        e.target.value = ''
      }
    },
    // 获取关联标识列表
    async getRelationLabel() {
      const parameter = {
        identifier_type: 3, // 代表标准属性标签
      }
      const res = await StdIdentifierService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.relationLabelList = res.data
      }
    },
    // 获取值类型列表
    async getValueTypeList() {
      const res = await StdClassAttributeService.getValueType()
      if (res && res.code === 0 && res.data) {
        this.valueTypeList = res.data
        this.$set(this.queryForm, 'valueType', this.valueTypeList[0].value)
      }
    },
    // 获取单位列表
    async getUnitList() {
      const parameter = {
        standard_id: this.standardId,
        sort: 'seq_no asc',
      }
      const res = await unitMeasureservice.unitList(parameter)
      if (res && res.code === 0 && res.data) {
        this.unitList = res.data
      }
    },
    async addAttribute() {
      this.attrDialog = true
      this.dialogTitle = this.$t('createStandardAttribute')
      this.getReferenceDataList()
      this.getPersonalityMetaDataList()
      this.queryForm.seqNo = await this.getMaxSeqNo()
      this.queryForm.length = 100
    },
    async getMaxSeqNo() {
      const res = await StdAttributeService.getMaxSeqno({
        standardId: this.standardId,
      })
      if (res && res.code === 0) {
        return res.data
      }
      return 0
    },
    async searchTableData() {
      this.tableLoading = true
      const parameter = {
        standard_id: this.standardId,
        keyword: this.keyword,
        pageno: this.pageNo,
        pagesize: this.pageSize,
      }
      const res = await StdAttributeService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
        _.forEach(this.tableData, (item) => {
          if (_.find(this.totalSelection, ['id', item.id])) {
            this.$nextTick(() => {
              this.$refs.multipleTable.toggleRowSelection(item, true)
            })
          }
          // 初始级的代码不允许编辑和删除
          if (
            [
              'Code',
              'Name',
              'ClassId',
              'ParentCode',
              'Revision',
              'Version',
              'FolderId',
              'ApproveStatus',
              'Supplier',
              'Discipline',
              'IsHistory',
              'IsGisLoad',
              'LLH',
              'DefaultCameraView',
              'Length',
              'Medium',
              'FlowDirection',
              'Nominal_Diameter',
            ].includes(item.code)
          ) {
            item.disabled = true
          }
        })
        if (res.page) {
          this.recordCount = res.page.recordCount
          this.pageNo = res.page.pageNo
          this.pageSize = res.page.pageSize
        }
        this.tableLoading = false
        this.$nextTick(() => {
          if (this.$refs.multipleTable) {
            this.$refs.multipleTable.doLayout()
          }
        })
      }
    },
    delAttr(selectList) {
      if (!selectList.length) {
        this.$message.info('请选择要删除的数据')
        return
      }
      const ids = selectList.map((item) => {
        return item.id
      })
      // if (selectList.some((item) => item.disabled)) {
      //   this.$message.warning('存在不可删除的数据')
      //   return
      // }
      this.$confirm(this.$t('confirmDeleteAttribute'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      }).then(async () => {
        const res = await StdAttributeService.remove({ data: ids })
        if (res && res.code === 0) {
          this.$message.success('删除成功')
          if (selectList.length === this.tableData.length && this.pageNo > 1) {
            this.pageNo -= 1
          }
          await this.searchTableData()
        }
      })
    },
    async viewAttr(id) {
      this.dialogTitle = this.$t('standardAttributeDetail')
      this.attrDialog = true
      const res = await StdAttributeService.detail({ id })
      if (res && res.code === 0 && res.data) {
        this.queryForm = res.data
      }
    },
    async editAttr(id) {
      this.dialogTitle = this.$t('editStandaardAttribute')
      this.attrDialog = true
      this.getReferenceDataList()
      await this.getPersonalityMetaDataList()
      this.getPersonalityMetaDataValue(id)
      const res = await StdAttributeService.detail({ id })
      if (res && res.code === 0 && res.data) {
        this.queryForm = res.data
      }
    },
    queryFormSave() {
      this.$refs.queryForm.validate(async (valid) => {
        if (valid) {
          if (this.queryForm.valueType === 3 && this.queryForm.decimalPoint > 30) {
            this.$message.warning(this.$t('theDecimalPointCannotExceed30'))
            return
          }
          if (this.queryForm.valueType === 3 && this.queryForm.length > 65) {
            this.$message.warning(this.$t('theLengthCannotExceed65'))
            return
          }
          if (this.queryForm.valueType === 2 && this.queryForm.length > 65) {
            this.$message.warning(this.$t('theLengthCannotExceed65'))
            return
          }
          if (this.queryForm.valueType === 3 && this.queryForm.decimalPoint <= 0) {
            // 数据类型为小数，得输入精度
            this.$message.warning(this.$t('theDecimalPointMustGreaterThan0'))
            return
          }
          if (this.queryForm.valueType === 3 && !this.queryForm.length) {
            // 数据类型为小数，得输入长度
            this.$message.warning(this.$t('valueTypeDecimalMusthEnterTheLength'))
            return
          }
          if (this.queryForm.valueType === 1 && !this.queryForm.length) {
            // 数据类型为字符串，得输入长度
            this.$message.warning(this.$t('valueTypeStringMusthEnterTheLength'))
            return
          }
          if (this.queryForm.valueType === 1 && !this.queryForm.length) {
            // 数据类型为长度，需要输入长度
            this.$message.warning(this.$t('theLengthMustGreaterThan0'))
            return
          }
          this.isLoading = true
          if (this.dialogTitle === this.$t('createStandardAttribute')) {
            await this.save()
          } else {
            this.update()
          }
        }
      })
    },
    async save() {
      const parameter = {
        model: this.queryForm,
      }
      parameter.model.standardId = this.standardId
      const res = await StdAttributeService.create(parameter)
      if (res && res.code === 0) {
        this.savePersonalityMetaData(res.data.id)
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.attrDialog = false
        this.searchTableData()
      }
      this.isLoading = false
    },
    async update() {
      const parameter = {
        model: this.queryForm,
      }
      parameter.model.standardId = this.standardId
      delete parameter.model.createdTime
      const res = await StdAttributeService.update(parameter)
      if (res && res.code === 0) {
        this.savePersonalityMetaData(this.queryForm.id)
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.attrDialog = false
        this.searchTableData()
      }
      this.isLoading = false
    },
    queryFormClose() {
      this.attrDialog = false
    },
    handleCurrentChange(num) {
      this.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.searchTableData()
    },
    // 获取个性化元数据列表
    async getPersonalityMetaDataList() {
      const res = await StdClassAttributeService.getPersonalityMetaDataList({
        stdPersonalityMetaDataType: 2,
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        this.personalityMetaData = await Promise.all(
          res.data.map(async (item) => {
            item.dataValue = null
            item.referenceItemsList = []
            if (item.dataType === '6') {
              this.$set(
                item,
                'referenceItemsList',
                await this.getReferenceItemsData(item.referenceData)
              )
            }
            return item
          })
        )
      }
    },
    // 保存个性化元数据
    async savePersonalityMetaData(id) {
      const params = []
      this.personalityMetaData.forEach((item) => {
        params.push({
          dataId: id,
          stdPersonalityMetaDataId: item.id,
          dataValue: item.dataValue,
        })
      })
      await StdClassAttributeService.savePersonalityMetaData(params)
    },
    // 编辑时获取个性化元数据值
    async getPersonalityMetaDataValue(id) {
      const res = await StdClassAttributeService.getPersonalityMetaDataValue({
        dataId: id,
      })
      if (res && res.code === 0) {
        this.personalityMetaData.map((item) => {
          res.data.forEach((val) => {
            if (item.columnName === val.columnName) {
              this.$set(item, 'dataValue', val.dataValue)
            }
          })
          return item
        })
      }
    },
    // 元数据输入框值变化
    metaDataInputChange(val, type, item) {
      // console.log((/^[+]{0,1}(\d+)$/g).test(val), '0000000')
      if (type === '2') {
        // 整数
        item.dataValue = val.replace(/[^0-9]/g, '')
      } else if (type === '3') {
        // 小数
        item.dataValue = val.replace(/[^0-9.]/g, '')
      }
    },
    // 获取参考数据字典值
    async getReferenceItemsData(id) {
      const params = {
        skipCount: 1,
        maxResultCount: 999,
        cateId: id,
      }
      const res = await ReferenceDataService.getCategoryItem(params)
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 打开分析弹框
    async openEffectAnalysis(type, ids) {
      if (!ids.length) {
        this.$message.warning(this.$t('tickData'))
        return
      }
      if (ids.length > 1) {
        this.$message.warning('请选择单个属性进行分析')
        return
      }
      let res = null
      if (type === 'effect') {
        // 影响分析
        this.analysisTitle = '影响分析'
        this.analysisType = 'effect'
        this.effectLoading = true
        res = await stdClassListService.getAttrImpactAnalysis({ id: ids[0] })
        this.effectLoading = false
      }
      this.effectAnalysisData = []
      if (res && res.code === 0 && res.data) {
        this.showEffectAnalysisDialog = true
        this.effectAnalysisData.push(res.data)
      }
    },
  },
}
</script>
<style lang="scss" scoped>

#StdAttribute {
  /deep/.el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
}

</style>
